export default "__VITE_ASSET__tUYKczOk__"